import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-toastify";
import { useStore, extractErrorMessage } from "../../../helpers";
import { TARS_CANVAS_CREATE_PATH } from "../tars-constants";
import { markTarsNotebookActivity } from "./useGetNotebooks";

export interface CreateCanvasPayload {
  notebook_id: number;
  name: string;
  type: string;
  version?: number;
  tags?: string[];
  more?: Record<string, unknown>;
}

const CREATE_SUCCESS_BY_TYPE: Record<string, string> = {
  thinkSpace: "ThinkSpace created successfully",
  analytics: "Analytics created successfully",
};

function createCanvasSuccessMessage(type: string): string {
  return CREATE_SUCCESS_BY_TYPE[type] ?? "Canvas created successfully";
}

export const useCreateCanvas = () => {
  const rootStore = useStore();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (payload: CreateCanvasPayload) => {
      const res = await rootStore.apiRequestHandler(
        TARS_CANVAS_CREATE_PATH,
        payload,
        "Failed to create canvas"
      );
      return res;
    },
    onSuccess: (_data, variables) => {
      toast.success(createCanvasSuccessMessage(variables.type));
      queryClient.invalidateQueries({ queryKey: ["tars", "canvas", "list"] });
      markTarsNotebookActivity(queryClient, variables.notebook_id);
    },
    onError: (error: unknown) => {
      toast.error(extractErrorMessage(error, "Failed to create canvas"));
    },
  });
};
